import React, { FC }                                 from 'react';
import { Icon }                                      from 'semantic-ui-react';
import { Position, Size }                            from '../../../../types';
import { CenteredContentContainer, StyledContainer } from '../../../containers';

interface Props {
    label?: string
}

const defaultProps: Props = {
    label: 'Loading Data...'
}

const SmallGearLoadingMessage: FC<Props> = ( props ) => {

    return (

            <StyledContainer padding={ Size.LG } position={ Position.RELATIVE }>

                <CenteredContentContainer className={ 'position--relative z-index--200' }>
                    <span>{ props.label }</span>
                </CenteredContentContainer>

                <StyledContainer fill={ 'area' } zIndex={ 100 } className={ 'opacity--25' }>
                    <CenteredContentContainer>
                        <Icon name={ 'cog' } size={ 'large' } color={ 'grey' } fitted loading style={ { fontSize: '9em', animationDuration: '25s' } }/>
                    </CenteredContentContainer>
                </StyledContainer>

            </StyledContainer>
    );
};

SmallGearLoadingMessage.defaultProps = defaultProps;

export { SmallGearLoadingMessage }
